import { observer } from 'mobx-react'
import React from 'react'
import styles from './OCRScopeJobDetailHeader.sass'
import cx from 'classnames'
import OCRScopingJobMainPanelViewModel from '../OCRScopingJobMainPanelViewModel'
import OCRScopeWork from '../../../../../../wunder/OCRScopeWork'

interface OCRScopeJobDetailHeaderFieldProps {
  children?: React.ReactNode
}

export function OCRScopeJobDetailHeaderField({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <div className={styles.detailHeaderField}>{children}</div>
}

export function OCRScopeJobDetailHeaderFieldName({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <span className={styles.detailHeaderFieldName}>{children}</span>
}

export function OCRScopeJobDetailHeaderFieldValue({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <span className={styles.detailHeaderFieldValue}>{children}</span>
}

export function OCRScopeJobDetailHeaderFieldSeparator() {
  return <span className={styles.detailHeaderFieldSeparator}>|</span>
}

interface OCRScopeJobDetailHeaderProps {
  vm: OCRScopingJobMainPanelViewModel
}
export default observer(function OCRScopeJobDetailHeader({
  vm,
}: OCRScopeJobDetailHeaderProps) {
  const selectedScopeWork = vm.selectedScopeWork
  if (selectedScopeWork === OCRScopeWork.none) {
    return
  }
  const isNotError =
    vm.isScopingInProgress || vm.isReadyToSubmit || vm.isCompleted
  const total = vm.editor.job.total

  return (
    <div className={styles.detailHeaderContainer}>
      <div className={styles.detailHeaderTitle}>
        {selectedScopeWork.jobName || selectedScopeWork.fileName}
      </div>
      <div className={styles.detailHeaderFieldContainer}>
        <OCRScopeJobDetailHeaderField>
          <OCRScopeJobDetailHeaderFieldName>
            Status
          </OCRScopeJobDetailHeaderFieldName>
          <span
            className={cx(
              styles.detailHeaderStatusField,
              isNotError
                ? styles.detailHeaderStatusFieldGreen
                : styles.detailHeaderStatusFieldRed,
            )}
          />
          <OCRScopeJobDetailHeaderFieldValue>
            {selectedScopeWork.statusName}
          </OCRScopeJobDetailHeaderFieldValue>
        </OCRScopeJobDetailHeaderField>

        {vm.canManageOCRScopingJobs && !vm.isErrorOccured && (
          <OCRScopeJobDetailHeaderField>
            <OCRScopeJobDetailHeaderFieldSeparator />
            <OCRScopeJobDetailHeaderFieldName>
              Confidence rating
            </OCRScopeJobDetailHeaderFieldName>
            <OCRScopeJobDetailHeaderFieldValue>
              {selectedScopeWork.confidenceLevel}%
            </OCRScopeJobDetailHeaderFieldValue>
          </OCRScopeJobDetailHeaderField>
        )}

        {vm.hasJob && (
          <OCRScopeJobDetailHeaderField>
            <OCRScopeJobDetailHeaderFieldSeparator />
            <OCRScopeJobDetailHeaderFieldName>
              Total
            </OCRScopeJobDetailHeaderFieldName>
            <OCRScopeJobDetailHeaderFieldValue>
              ${total}
            </OCRScopeJobDetailHeaderFieldValue>
          </OCRScopeJobDetailHeaderField>
        )}

        <OCRScopeJobDetailHeaderField>
          <OCRScopeJobDetailHeaderFieldSeparator />
          <OCRScopeJobDetailHeaderFieldName>
            Created by
          </OCRScopeJobDetailHeaderFieldName>
          <OCRScopeJobDetailHeaderFieldValue>
            {selectedScopeWork.createdByName}
          </OCRScopeJobDetailHeaderFieldValue>
        </OCRScopeJobDetailHeaderField>
      </div>
    </div>
  )
})
